<p-toast></p-toast>
<div *ngIf="groupInvoiceForm" [formGroup]="groupInvoiceForm">
    <div>
        <div class="top-container">
            <div>
                <h3>
                    Encode group invoice
                </h3>
            </div>
            <div class="global-form-container">
                <div>
                    <p>
                        *School
                    </p>
                    <p-dropdown placeholder="SELECT SCHOOL" [options]="schools" optionLabel="name" formControlName="school"
                        [filter]="true" filterBy="name" (onChange)="updateBookingList()"></p-dropdown>
                </div>
                <div>
                    <p>
                        Currency
                    </p>
                    <p-dropdown [options]="currencies" optionLabel="isoCode" formControlName="currency"></p-dropdown>
                </div>
                <div>
                    <p>
                        Type
                    </p>
                    <p-dropdown [options]="paymentTypes" formControlName="paymentType" optionLabel="name"></p-dropdown>
                </div>
                <div>
                    <p>
                        *Total Invoice amount
                    </p>
                    <input pInputText formControlName="totalAmount">
                </div>
                <div>
                    <p>
                        *Date of invoice
                    </p>
                    <p-calendar formControlName="date" dateFormat="dd/mm/yy"></p-calendar>
                </div>
                <div>
                    <p>
                        *Due date
                    </p>
                    <p-calendar formControlName="dueDate" dateFormat="dd/mm/yy"></p-calendar>
                </div>
                <div>
                    <p>
                        *Invoice number
                    </p>
                    <input pInputText formControlName="invoiceNumber">
                </div>
                <div>
                    <p>
                        Comment
                    </p>
                    <input pInputText formControlName="comment">
                </div>
            </div>
            <div class="submit-button-container">
                <p-button label="Submit" [disabled]="uploadingInvoices" (onClick)="uploadInvoices()"></p-button>
            </div>
        </div>
    </div>
    <p-table [value]="invoiceFormArray.controls">
        <ng-template pTemplate="header">
            <tr>
                <th>
                    Booking
                </th>
                <th>
                    From
                </th>
                <th>
                    To
                </th>
                <th>
                    Amount
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-form let-rowIndex="rowIndex">
            <ng-container formArrayName="invoices">
                <tr [formGroupName]="rowIndex">
                    <td>
                        <p-dropdown placeholder="SELECT BOOKING" [options]="bookings" optionLabel="label"
                            [filter]="true" filterBy="label" formControlName="booking"></p-dropdown>
                    </td>
                    <td>
                        {{form.value.booking?.startDate | date: 'dd/MM/yyyy'}}
                    </td>
                    <td>
                        {{form.value.booking?.endDate | date: 'dd/MM/yyyy'}}
                    </td>
                    <td>
                        <input pInputText formControlName="amount">
                    </td>
                </tr>
            </ng-container>
        </ng-template>
    </p-table>
</div>